/**
 *
 * @component 个人中心/我的方案/项目管理——添加方案
 *
 **/
import React, { useState } from 'react';
import {
    Button,
    Progress,
    Pagination,
    // Spin,
} from 'antd';
import ProjectCard from '&/components/ProjectSpace/ProjectCard';
import './AddSchemeModal.scss';
function AddSchemeModal(props) {
    const { visible, setVisible } = props;

    useEffect(() => {
        const m = window.innerWidth - document.body.clientWidth;
        document.documentElement.style.marginRight = m + 'px';
        return () => {
            document.documentElement.style.marginRight = 0;
        };
    }, []);
    const [queryForm /* setQueryForm */] = useState({});
    const [result /* setResult */] = useState({
        list: [],
        total: 0,
    });

    // const closeModal = () => {
    //     setVisible(false);
    // };

    function handlePageChange() {}
    function cancel(params) {
        setVisible(false);
    }

    const [, /* active */ setactive] = useState(0);
    function selectScheme(idx) {
        setactive(idx);
    }
    return (
        visible && (
            <div className="add-scheme">
                <header className="add-scheme-header">
                    <div className="add-scheme-title">添加方案</div>
                    <div className="space-size">
                        <span className="scheme-selected">已选：2/10</span>
                        占用空间:
                        <div style={{ width: '5rem' }}>
                            <Progress
                                percent={(2.3 / 5) * 100}
                                size="small"
                                strokeColor="#df773c"
                                trailColor="#BEC4D6"
                                showInfo={false}
                            />
                        </div>
                        2.3G/5G
                    </div>
                    <i
                        onClick={cancel}
                        className="icon-close filled close-icon"
                    />
                </header>
                <div className="add-scheme-list">
                    <ProjectCard
                        onClick={() => selectScheme()}
                        single={true}
                        hasMenu={false}
                        className={`project-card--active`}
                    />
                    <Pagination
                        size="small"
                        current={queryForm.page}
                        onChange={handlePageChange}
                        pageSize={queryForm.pageNum}
                        total={result.total}
                        showSizeChanger={false}
                        showTotal={total => intl.get('base.total', { total })}
                    />
                </div>
                <footer className="add-scheme-footer">
                    <Button onClick={cancel}>取消</Button>
                    <Button type="primary">确定</Button>
                </footer>
            </div>
        )
    );
}

export default AddSchemeModal;
